import React, { useEffect, useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

/**
 * UndoToast — auto-dismissing toast with undo action (§3.5-5)
 * Shows for `duration` ms then auto-dismisses. Clicking "Undo" triggers onUndo.
 */
export function UndoToast({ message, onUndo, onDismiss, duration = 3000 }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onDismiss) onDismiss();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onDismiss]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-gray-900 text-white px-4 py-2.5 shadow-lg text-sm" style={{ borderRadius: 'var(--radius-md)' }}>
      <span>{message}</span>
      {onUndo && (
        <button
          onClick={() => { onUndo(); setVisible(false); }}
          className="font-semibold text-primary-300 hover:text-primary-200 underline"
        >
          Undo
        </button>
      )}
      <button
        onClick={() => { setVisible(false); if (onDismiss) onDismiss(); }}
        className="text-gray-400 hover:text-white ml-1"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>
  );
}
